import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';

const ModuleUsageChart = ({ data, loading }) => {
    const { t } = useLanguage();
    if (loading) {
        return (
            <div className="card shadow-sm h-100">
                <div className="card-body">
                    <h5 className="card-title mb-4">{t('metrics.moduleUsage.title')}</h5>
                    <div className="placeholder-glow">
                        <div className="placeholder col-12" style={{height: '300px'}}></div>
                    </div>
                </div>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="card shadow-sm h-100">
                <div className="card-body">
                    <h5 className="card-title mb-4">{t('metrics.moduleUsage.title')}</h5>
                    <div className="text-center text-muted py-5">
                        <i className="bi bi-bar-chart" style={{fontSize: '3rem'}}></i>
                        <p className="mt-3">{t('metrics.noData')}</p>
                    </div>
                </div>
            </div>
        );
    }

    const maxValue = Math.max(...data.map(d => d.total_consultas));
    const getBarColor = (modulo) => {
        if (modulo === 'Policy Navigator') return '#3b82f6';
        if (modulo === 'Journal Finder') return '#10b981';
        if (modulo === 'Concursos') return '#f59e0b';
        return '#6b7280';
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h5 className="card-title mb-4">
                    <i className="bi bi-bar-chart-fill me-2 text-primary"></i>
                    {t('metrics.moduleUsage.title')}
                </h5>
                
                <div className="mt-4">
                    {data.map((item, index) => (
                        <div key={index} className="mb-4">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="fw-semibold">{item.modulo}</span>
                                <span className="text-muted">{item.total_consultas} {t('metrics.moduleUsage.queries')} ({item.porcentaje}%)</span>
                            </div>
                            <div className="progress" style={{height: '30px'}}>
                                <div 
                                    className="progress-bar d-flex align-items-center justify-content-end px-3"
                                    role="progressbar"
                                    style={{
                                        width: `${(item.total_consultas / maxValue * 100)}%`,
                                        backgroundColor: getBarColor(item.modulo)
                                    }}
                                    aria-valuenow={item.total_consultas}
                                    aria-valuemin="0"
                                    aria-valuemax={maxValue}
                                >
                                    <span className="fw-semibold">{item.total_consultas}</span>
                                </div>
                            </div>
                            <div className="small text-muted mt-1">
                                <i className="bi bi-people-fill me-1"></i>
                                {item.usuarios_unicos} {t('metrics.moduleUsage.uniqueUsers')}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-4 pt-3 border-top">
                    <div className="row text-center">
                        <div className="col-4">
                            <div className="d-flex align-items-center justify-content-center">
                                <span className="badge me-2" style={{backgroundColor: '#3b82f6', width: '20px', height: '12px'}}></span>
                                <small className="text-muted">{t('metrics.moduleUsage.legend.policyNavigator')}</small>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="d-flex align-items-center justify-content-center">
                                <span className="badge me-2" style={{backgroundColor: '#10b981', width: '20px', height: '12px'}}></span>
                                <small className="text-muted">{t('metrics.moduleUsage.legend.journalFinder')}</small>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="d-flex align-items-center justify-content-center">
                                <span className="badge me-2" style={{backgroundColor: '#f59e0b', width: '20px', height: '12px'}}></span>
                                <small className="text-muted">{t('metrics.moduleUsage.legend.concursos')}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModuleUsageChart;
